export default "__VITE_ASSET__C6B3ZjuR__"